import { collections } from '@/mocks/home'
import SectionHeading from './SectionHeading'

export default function CollectionsSection() {
  return (
    <section id="collections" className="border-b border-background-200/80 bg-secondary-50/60">
      <div className="mx-auto w-full max-w-[1240px] px-4 py-12 md:px-6 md:py-16">
        <SectionHeading
          eyebrow="Index"
          title="围观合集 · 索引"
          desc="按题材归好档的合集入口，想系统性看一条线就进这里。编号越大，收纳的讨论越新。"
          actionLabel="查看索引说明"
          actionHref="#subscribe"
        />

        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {collections.map((item, index) => (
            <a
              key={item.id}
              href="#front-row"
              className="group flex flex-col rounded-lg border border-background-200/80 bg-background-50 p-5 transition-colors hover:border-secondary-400 hover:bg-background-100/70 cursor-pointer"
            >
              <div className="mb-4 flex items-start justify-between">
                <div className="h-14 w-14 shrink-0 overflow-hidden rounded-md border border-background-200/80">
                  <img
                    src={item.image}
                    alt={`${item.name} 合集索引 51.cg 群众围观`}
                    title={`${item.name} 51.cg 围观合集`}
                    className="h-full w-full object-top"
                  />
                </div>
                <span className="font-heading text-2xl font-bold text-background-300 transition-colors group-hover:text-secondary-300">
                  {String(index + 1).padStart(2, '0')}
                </span>
              </div>

              <div className="mb-2 flex items-center gap-2">
                <h3 className="font-heading text-base font-bold text-foreground-950 transition-colors group-hover:text-secondary-800">
                  {item.name}
                </h3>
                <span className="rounded-md bg-accent-100 px-1.5 py-0.5 font-label text-[11px] text-accent-800">
                  {item.tag}
                </span>
              </div>
              <p className="flex-1 text-sm leading-relaxed text-foreground-600">{item.desc}</p>

              <div className="mt-4 flex items-center justify-between border-t border-background-200/80 pt-3 text-xs text-foreground-500">
                <span className="inline-flex items-center gap-1">
                  <i className="ri-folder-2-line text-sm text-secondary-600"></i>
                  收录 {item.count} 条
                </span>
                <span className="inline-flex items-center gap-1 text-secondary-700 transition-transform group-hover:translate-x-0.5">
                  进入合集
                  <i className="ri-arrow-right-line text-sm"></i>
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  )
}